import React from 'react';
import { HomeSectionHeader } from '../home/HomeSectionHeader';
import { HOME_SURFACES } from '../home/homeSurfaces';
import { cn } from '../../lib/utils';

export function MarketingPageHero({
  badge,
  title,
  subtitle,
  actions,
  children,
  className,
}: {
  badge?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <section
      className={cn(
        HOME_SURFACES.ivory,
        'pt-28 pb-16 md:pt-32 md:pb-20',
        className
      )}
    >
      <div className="section-padding">
        <HomeSectionHeader
          badge={badge}
          title={title}
          subtitle={subtitle}
          titleAs="h1"
        />
        {actions ? (
          <div className="mb-14 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
            {actions}
          </div>
        ) : null}
        {children}
      </div>
    </section>
  );
}
